<div class="container mx-auto p-8 h-screen overflow-y-auto">
  <h1 class="text-3xl font-bold mb-8 text-white">Settings</h1>
  <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
    <h2 class="text-2xl font-semibold mb-6 text-gray-800">Application Settings</h2>
    <p class="mb-6 text-gray-600">Add additional instructions for the AI to follow.</p>
    <div class="flex flex-col gap-4">
      <div class="border border-gray-200 rounded-lg p-4 flex flex-row justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors duration-200" (click)="openDialog('llm')">
        <div>
          <h3 class="text-lg font-medium text-gray-800">LLM additional instructions</h3>
          <p class="text-sm text-gray-500">Customize how the AI responds to your queries.</p>
        </div>
        <ng-icon name="heroChevronRight" class="w-6 h-6 text-gray-400"></ng-icon>
      </div>
      <div class="border border-gray-200 rounded-lg p-4 flex flex-row justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors duration-200" (click)="openDialog('ui')">
        <div>
          <h3 class="text-lg font-medium text-gray-800">UI Colour Scheme</h3>
          <p class="text-sm text-gray-500">Switch between light and dark themes for the interface.</p>
        </div>
        <ng-icon name="heroChevronRight" class="w-6 h-6 text-gray-400"></ng-icon>
      </div>
    </div>
  </div>
</div>

<p-dialog [(visible)]="showDialog" maskStyleClass="backdrop-blur-sm" [modal]="true" [draggable]="false" [resizable]="true" [closable]="false" [style]="{width: '50vw', minWidth: '300px', maxWidth: '800px'}" [contentStyle]="{padding: '2rem', borderRadius: '0.75rem'}">
  <div class="flex flex-col">
    <div class="flex justify-between items-center mb-6">
      <h2 class="text-2xl font-semibold text-blue-500">{{dialogTitle}}</h2>
      <button (click)="closeDialog()" class="btn btn-ghost btn-sm hover:bg-gray-100 rounded-full p-2 focus:outline-none">
        <ng-icon name="heroXMark" class="w-5 h-5 text-gray-500"></ng-icon>
      </button>
    </div>
    <textarea 
      class="textarea textarea-bordered w-full h-32 mb-6 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent rounded-lg resize-none" 
      [(ngModel)]="dialogContent"
      [placeholder]="dialogPlaceholder"></textarea>
    <div class="flex justify-end gap-3">
      <button class="btn btn-primary bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors duration-200" (click)="saveDialogContent()">Save</button>
      <button class="btn btn-ghost text-gray-600 hover:bg-gray-100 px-6 py-2 rounded-lg transition-colors duration-200" (click)="closeDialog()">Cancel</button>
    </div>
  </div>
</p-dialog>

<!-- Unified Settings Dialog -->
<!-- <div *ngIf="showDialog" class="fixed inset-0 bg-base-200 bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-base-100 p-6 rounded-lg w-full max-w-2xl">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-xl font-bold">{{dialogTitle}}</h2>
      <button (click)="closeDialog()" class="btn btn-ghost btn-sm">
        <ng-icon name="heroXMark" class="w-6 h-6"></ng-icon>
      </button>
    </div>
    <textarea 
      class="textarea textarea-bordered w-full h-15 mb-4" 
      [(ngModel)]="dialogContent"
      [placeholder]="dialogPlaceholder"></textarea>
    <div class="flex justify-end gap-2">
      <button class="btn btn-primary" (click)="saveDialogContent()">Save</button>
      <button class="btn btn-ghost" (click)="closeDialog()">Cancel</button>
    </div>
  </div>
</div> -->


